<template>
    <div class="study-activity-mini" v-if="activity && hasActivity">
        <section-header title="Study Activity" icon="fa-calendar-days" :to="{name: 'study-activity'}" link-text="Details"/>
        <ui-card>
            <b-message v-if="activity.review && activity.review.state !== 'normal'" :type="activity.review.state === 'audit_risk' ? 'is-danger' : 'is-warning'" size="is-small" class="mb-3">
                <strong><i class="fas fa-triangle-exclamation mr-2"></i>Unusual activity on your account</strong> &mdash; review your study log details.
            </b-message>
            <activity-heatmap
                :days="activity.days"
                :weeks="activity.weeks"
                :range-from="activity.range.from"
                :range-to="activity.range.to"
            />
            <div class="mini-summary mt-3">
                <strong>{{ last30Hours }}</strong> hours logged in the last 30 days
            </div>
        </ui-card>
    </div>
</template>

<script>
    import moment from "moment";
    import {axiosInstance} from "../../http_client";
    import SectionHeader from "../framework/SectionHeader";
    import UiCard from "../UiCard";
    import ActivityHeatmap from "../studyActivity/ActivityHeatmap";

    /**
     * Three-month heatmap plus one number. Renders the heatmap directly
     * rather than the full StudyActivityPanel (legend, schedule strip,
     * flagged-day list belong on the Study Activity page). Hidden until the
     * student has logged something.
     */
    export default {
        name: "StudyActivityMini",
        components: {SectionHeader, UiCard, ActivityHeatmap},
        data() {
            return {activity: null};
        },
        computed: {
            hasActivity() {
                return (this.activity.days || []).some(d => d.mins > 0);
            },
            last30Hours() {
                const cutoff = moment().subtract(30, 'days').format('YYYY-MM-DD');
                const mins = (this.activity.days || []).filter(d => d.date >= cutoff).reduce((s, d) => s + (d.mins || 0), 0);
                return Math.round(mins / 60 * 10) / 10;
            }
        },
        methods: {
            async load() {
                try {
                    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
                    // axiosInstance, not the cachios client: a ttl of 0 would
                    // cache this forever (same gotcha as StudyActivityPanel)
                    const {data} = await axiosInstance.get('app/study-activity', {params: {tz, months: 3}});
                    this.activity = data;
                } catch (err) {
                    this.activity = null;
                }
            }
        },
        mounted() {
            this.load();
        }
    };
</script>

<style lang="scss" scoped>
    .mini-summary {
        font-size: 0.85rem;
        color: #555;
    }
</style>
